module.exports = __webpack_public_path__ + "assets/shape-square.92cf046d.svg";